"use strict";

var _classCallCheck = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/inherits");

var _taggedTemplateLiteral = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var ToolbarButton_1 = __importDefault(require("./ToolbarButton"));

var ToolbarSeparator_1 = __importDefault(require("./ToolbarSeparator"));

var FlexibleWrapper = styled_components_1.default.div(_templateObject());

var ToolbarMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ToolbarMenu, _React$Component);

  function ToolbarMenu() {
    _classCallCheck(this, ToolbarMenu);

    return _possibleConstructorReturn(this, _getPrototypeOf(ToolbarMenu).apply(this, arguments));
  }

  _createClass(ToolbarMenu, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          view = _this$props.view,
          items = _this$props.items;
      var state = view.state;
      var Tooltip = this.props.tooltip;
      return React.createElement(FlexibleWrapper, null, items.map(function (item, index) {
        if (item.name === "separator" && item.visible !== false) {
          return React.createElement(ToolbarSeparator_1.default, {
            key: index
          });
        }

        if (item.visible === false || !item.icon) {
          return null;
        }

        var Icon = item.icon;
        var isActive = item.active ? item.active(state) : false;
        return React.createElement(ToolbarButton_1.default, {
          key: index,
          onClick: function onClick() {
            return item.name && _this.props.commands[item.name](item.attrs);
          },
          active: isActive
        }, React.createElement(Tooltip, {
          tooltip: item.tooltip,
          placement: "top"
        }, React.createElement(Icon, {
          color: _this.props.theme.toolbarItem
        })));
      }));
    }
  }]);

  return ToolbarMenu;
}(React.Component);

exports.default = styled_components_1.withTheme(ToolbarMenu);